module.exports = __webpack_public_path__ + "static/media/icone_oeuvreprotestante.789fbfdd.svg_old";